<template>
  <div>
    <img
      class="img-fluid"
      src="@/assets/img/ilustrations/ilustration03.jpg"
      alt=""
    />
    <FormWizardStepHeader
      class="mt-30"
      title="Success! You’ve submitted your investor profile for review."
      description="You’ll hear from us once approved or if we have any questions. In the meantime, get started on finding startups matching your preferences."
    />
    <div>
      <router-link tag="button" to="/startups" class="btn mr-10"
        >Browse startups</router-link
      >
      <router-link tag="button" :to="investor.adminUrl" class="btn btn-light"
        >Go to dashboard</router-link
      >
    </div>
  </div>
</template>
<script>
import FormWizardStepHeader from '@/components/FormWizardStepHeader'
export default {
  components: {
    FormWizardStepHeader
  },
  props: {
    investor: {
      type: Object,
      required: true
    }
  }
}
</script>
